<template>
<div>
  <modal-view-base ref="modalView" v-show="isOpen" @close="onClose" @mask-click="onClose" :container-width="'40vw'">
    <template slot="header">
      <h2>{{ viewTitle }}</h2>
    </template>
    <template slot="body">
      <div class="form-body">
        <div class="row">
          <div class="col">
            <alerter ref="alertbox"/>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <grid ref="grid" 
              v-bind:layout="gridLayout"
              v-on:list-item-clicked="listItemClicked"
              v-on:list-item-clicked-right="listItemClickedRight"/>
          </div>
        </div>
        <loading-spinner v-bind:loading="isBusy"/>
      </div>
      <context-menu ref="menu">
        <ul slot-scope="child">
          <li v-if="allowEdit(child.data)" v-on:click="setAsDefaultLayout(child.data)">{{ $t("grid.maintenanceview.set_as_default_layout") }}</li>
          <li v-if="allowEdit(child.data)" class="delete" v-on:click="deleteItem(child.data)">{{ $t("delete") }}</li>
        </ul>
      </context-menu>
    </template>

    <template slot="footer">
      <span class="badge badge-light badge-current-layout">{{$t('selected')}}: {{layoutName}}</span>
    </template>

  </modal-view-base>

  <flex-grid-layout-maintenance-view ref="createNew" />
</div>
</template>
<script>
import { GridController } from 'controller/gridcontroller.js';

import Grid from 'components/Grid/SimpleGrid.vue';
import Alerter from 'components/Alerter.vue';
import TextInput from 'components/TextInput.vue';
import FlexGridLayoutMaintenanceView from 'components/Grid/FlexGridLayoutMaintenanceView.vue';
import ContextMenu from 'components/ContextMenu.vue';
import ModalComponent from 'components/ModalComponent.vue';
import LoadingSpinner from 'components/LoadingSpinner.vue';
import {Grid as GridSecurity} from 'libs/classes/security.js';

export default {
  name: 'FlexGridLayoutSearch',
  components: {
    'alerter': Alerter,
    'grid': Grid,
    'flex-grid-layout-maintenance-view': FlexGridLayoutMaintenanceView,
    'modal-view-base': ModalComponent,
    'context-menu': ContextMenu,
    'loading-spinner': LoadingSpinner
  },
  props: {
    webController: String,
    controlName: String,
    existingFlexGridColumns: Array,
    layoutName: String
  },
  data: function () {
    return {
      searchKey: '',
      listItems: [],
      listItemsCopy: [],
      gridLayout: [
        { Visible: true, ColumnWidth: 150, ColumnAlignment: 0, FieldName: 'Name' },
        { Visible: true, ColumnWidth: 100, ColumnAlignment: 0, FieldName: 'LayoutType' },
        { Visible: true, ColumnWidth: 100, ColumnAlignment: 0, FieldName: 'DefaultLayout' },
        { Visible: true, ColumnWidth: 100, ColumnAlignment: 0, FieldName: 'CreateDate' }
      ],
      isBusy: false,
      gridcontroller: null,
      viewTitle: this.$t('view.view_manager'),
      allowChangeSystemViews: false,
      allowChangeUserViews: false,
      isOpen: false
    };
  },
  async created() {
    this.allowChangeSystemViews = await this.$authorize(GridSecurity.AllowChangeSystemViews);
    this.allowChangeUserViews = await this.$authorize(GridSecurity.AllowChangeUserViews);
    this.$log('get grid settings', this.allowChangeSystemViews, this.allowChangeUserViews);
  },
  mounted () {
    this.gridcontroller = new GridController(this.webController);
  },
  methods: {
    showModal: function () {
      this.getData();
      this.isOpen = true;
    },
    onClose() {
      this.isOpen = false;
    },
    colCheckBoxUpdate: function (col, selected) {
      this.$set(col, 'selected', selected);
      this.$forceUpdate();
    },
    getData: function () {
      let self = this;
      let obj = {
        ControlName: this.controlName,
        Filter: this.getFilter()
      };
      self.isBusy = true;

      this.gridcontroller.GetFlexGridLayouts(obj).then(res => {
        // // load data in grid
        self.$refs.grid.loadData(res.Meta.Columns, res.Data);
      }).catch(error => self.showAlert('Fout bij het ophalen van de gegevens.', error)).finally(() => {
        self.isBusy = false;
      });
    },
    listItemClicked: function (val) {
      this.$emit('list-item-clicked', val.obj);
    },
    listItemClickedRight: function (val) {
      // val.event = event;
      // val.obj = object selected
      // val.type = 'row' or 'col'
      this.$refs.menu.open(val.event, { obj: val.obj, type: val.type });
    },
    setAsDefaultLayout: function (val) {
      let row = val.obj[0];
      const self = this;
      let obj = { AutoID: row.AutoID, controlName: this.controlName };
      this.gridcontroller.UpdateDefaultLayout(obj).then(res => {
        // load data in grid
        this.getData();
      }).catch(error => self.showAlert('Fout bij het updaten van de weergave.', error));
    },
    allowEdit: function (val) {
      let view = val.obj[0];
      if (this.allowChangeUserViews && view.LayoutType === 1) {
        return true;
      } else if (this.allowChangeSystemViews && view.LayoutType === 0) {
        return true;
      }
      return false;
    },
    deleteItem: function (val) {
      let row = val.obj[0];
      const self = this;
      let obj = { AutoID: row.AutoID };

      const onYes = () => {
        self.gridcontroller.DeleteFlexGridLayout(obj).then(res => {
          // load data in grid
          this.getData();
          this.$emit('list-item-deleted', row);
        }).catch(error => self.showAlert('Fout bij het verwijderen van de layout.', error));
      };

      this.$dialogs.confirm(
        this.$t('grid.gridlayoutsearch.delete_confirm_msg'),
        this.$t('grid.gridlayoutsearch.delete_confirm_title'), 
        onYes,
        null
      );
    },
    showAlert: function (msg, error) {
      console.error(error);
      this.$refs.alertbox.showError(msg);
    },
    getFilter: function () {
      return {
        PageSize: 1000,
        PageIndex: 0,
        FlexGridLayoutColumns: this.gridLayout,
        DataFilter: { ControlName: this.controlName }
      };
    },
    mapLayout: function (layout, metadata) {
      var mapped = layout.map(x => {
        let meta = metadata.find(m => m.FieldName === x.FieldName);
        let newObj = Object.assign(meta, x);
        return newObj;
      });
      return mapped;
    }
  }
};
</script>

<style lang="scss">
.flex-grid-layout-search {
    .form-control.text-input {
        width: 100%;
    }
    .fd-list {
        .fd-item {
            cursor: pointer;
            &:hover {
                background-color: #f9f9f9;
            }
        }
    }
    .search-bar-container {
        margin-bottom: 16px;
    }
    .custom-select {
        &.transparent {
            opacity: 0.4;
        }
    }
}
</style>
<style lang="scss" scoped>
.grid-wrapper {
  max-height: 65vh;
  overflow-y: auto;
}
.badge-current-layout{
  font-size: 1em;
  padding-top: 5px;
}
</style>
